/**
 * E.g. Returns 25 September 2015 (numeric day, long month, numeric year)
 * @param {date} date The date to format
 */
export const longDate = (date) => {
  if (!date) return "";
  const options = { day: "numeric", month: "long", year: "numeric" };
  return new Date(date).toLocaleDateString("en-ZA", options);
};

export default {
  longDate,
};
